import * as React from 'react';
import { Panes, Pane } from '../../components/Panes';
import { useAddModelField } from '../../data/modelFields';
import { useHistory } from '../../hooks';
import { ModelFieldForm } from '../../forms/ModelFieldForm';
import { SubmitButton } from '../../components/SubmitButton';
import { PaneButton } from '../../components/PaneButton';
import { Form } from '../../components/Form';
import { useOrgId } from '../../auth';
import { useHasPermission } from '../../auth';
import { Permissions } from '@rivison-inc/ft-types';
import { BackButton } from '../../components/BackButton';

export function AddModelFieldsPage() {
  const history = useHistory();
  const orgId = useOrgId();
  const canWrite = useHasPermission(Permissions.SETTINGS_WRITE);
  const { addModelField } = useAddModelField();

  if (!canWrite) {
    return <></>;
  }

  return (
    <Form 
      initialValues={{
        name: '',
        orgId: orgId || '',
        includeInReports: true,
      }}
      onSubmit={async (modelField) => {
        await addModelField(modelField);
        history.goBack();
      }}
    >
      <Panes backgroundColor="light" leftButton={<BackButton />}>
        <Pane
          title="Add Model Field"
          rightButton={<SubmitButton as={PaneButton} showFeedback label="Add" />}
        >
          <ModelFieldForm />
        </Pane>
      </Panes>
    </Form>
  )
}
  
